import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import { yesNoModal } from '../../actions/common'
import {fetchAnalisisExtracciones, cambiarEyaculadoEliminadoAnalisisExtracciones, cambiarVigiladoAnalisisExtracciones, onDeleteAnalisisExtraccion} from '../../actions/analisisExtracciones/analisisExtracciones'
import AnalisisExtracciones from '../../components/analisisExtracciones/AnalisisExtracciones'
import {obtenerDatosPanelControl} from '../../actions/panelControl/panelControl'

export function mapStateToProps (state) {
  return {
    ...state.analisisExtracciones,
    auth: state.auth,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    panelControl: state.panelControl
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchAnalisisExtracciones,
      cambiarEyaculadoEliminadoAnalisisExtracciones,
      cambiarVigiladoAnalisisExtracciones,
      onDeleteAnalisisExtraccion,
      yesNoModal,
      obtenerDatosPanelControl
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AnalisisExtracciones))